/**
 * Builds a paginated URL by replacing trailing /page/limit segments.
 */
export function buildPaginatedPath(
  pathname: string,
  page: number | string,
  limit: number | string,
): string {
  const base = pathname.replace(/\/\d+\/\d+$/, '');

  return `${base}/${page}/${limit}`;
}
